export type { OptionGroupSlots, OptionGroupProps, OptionGroupState } from '@fluentui/react-combobox';
